import { IResponse, IResponseWithTotal, YN } from './common.api.model';

export interface ITestType {
  examTypeCode: number;
  eduStepCode: string;
  examDiv: string;
  examTypeName: string;
  memo: string;
  subject?: ITestTypeSubject[];
};

export interface ITestTypeSubject {
  examTypeSubjectCode: number;
  questionCount: number;
  seq: number;
  subjectName: string;
  totalPoint: number;
}

export interface IGetTestType extends IResponse<ITestType> {};

export interface IGetTestTypes extends IResponse<ITestType[]> {};

export interface IGetTestTypesParams {
  eduStepCode?: string;
};

export interface IPostTestTypeReq {
  eduStepCode: string;
  examDiv: string;
  examTypeName: string;
  memo: string;
};

export interface ITestSubject {
  subjectCode: number;
  subjectName: string;
}

export interface IGetTestSubjects {
  result: string;
  data: ITestSubject[];
}

export interface ITestSubjectReq {
  subjectCode: number;
  totalPoint: string;
}

export interface ITestSubjectSeqReq {
  examTypeSubjectCode: number;
  seq: number;
}

export interface IPrtItem {
  status?: string;
  prtLevelCode?: number;
  srtScore: number | string | null;
  endScore: number | string | null;
  examTypeCode: number | null;
  examTypeName?: string;
}

export interface IGetPrtItems {
  result: string;
  data: IPrtItem[];
}

export interface IPtItem {
  status?: string;
  platLevelCode?: number;
  srtScore: number | string | null;
  endScore: number | string | null;
  targetExamTypeCode: number | null;
  targetExamTypeName?: string;
}

export interface IGetPtItems {
  result: string;
  data: IPtItem[];
}

export interface IPtCurriculum {
  status?: string;
  platCurriculumCode?: number;
  srtScore: number | string | null;
  endScore: number | string | null;
  courseCode: number | null;
  courseName?: string;
}

export interface IGetPtCurriculums {
  result: string;
  data: IPtCurriculum[];
}

export interface IExam {
  examCode: number;
  examTypeCode: number;
  examDiv: string;
  examName: string;
  openYn: string;
  year: string;
  semesterCode: number;
}

export interface IGetExams extends IResponseWithTotal<IExam[]> {}

export interface IExamParams {
  pageNo: number;
  perPage: number;
  examDiv?: string[];
  examTypeCode?: number;
  year?: string;
  semesterCode?: number;
  examName?: string;
  semesterType?: string;
}

export interface IExamInfo {
  examCode: number;
  eduStepCode: string;
  examDiv: string;
  examTypeCode: number;
  writingExamReqDtoList: ISkillExam[];
  examName: string;
  year: string;
  semesterCode: number;
  testSeq: number;
  openYn: string;
  checkYn: string;
  attachFileCode: number;
  attachFile: {
    attachFileCode: number;
    fileLocation: string;
    fileSeq: number;
    originalName: string;
  }[];
  memo: string;
  semesterType: string;
}

export interface ISkillExam {
  speakingExamCode?: number;
  speakingExamName?: string;
  srtScore: string|number;
  endScore: string|number;
};

export const InitialSkillExam: ISkillExam = {
  speakingExamCode: undefined,
  speakingExamName: '',
  srtScore: '',
  endScore: '',
};

export interface IGetExamInfo extends IResponse<IExamInfo> {};

export interface IPublishExamReq {
  openYn: string;
}

export interface IExamSubject {
  examSubjectCode: number;
  examTypeSubjectCode: number;
  subjectCode: number;
  subjectName: string;
  testCode: number;
  testTitle: string;
  quizCount: number;
  subjectTime: number;
}

export interface IGetExamSubjects {
  result: string;
  data: IExamSubject[];
}

export interface IExamPaper {
  testCode: number;
  testTitle: string;
  subjectCode: number;
  subjectName: string;
  quizCount: number;
}

export interface IGetExamPapers {
  result: string;
  data: IExamPaper[];
}

export interface IExamPaperParams {
  subjectCode?: string;
  yearCode?: string;
  timeCode?: string;
  examPaperBrnCode?: string;
  testTitle?: string;
}

export interface IExamPaperReq {
  testCode?: number;
  subjectTime?: number;
}

export interface IExamPurpose {
  codeName: string;
  examPaperBrnCode: number;
  orderSeq: number;
}

export interface IGetExamPurposes {
  result: string;
  data: IExamPurpose[];
}

export interface IExamQuizzes {
  subjectCode: number;
  subjectName: string;
  totalPoint: number;
  quiz: {
    quizCode: number;
    quizSeq: number;
    quizTime: number;
    quizAnswer: string;
    skillCode: number;
    skillName: string;
    subSkillCode: number | null;
    subSkillName: string | null;
    scorePerQuiz: number;
  }[];
}

export interface IGetExamQuizzes {
  result: string;
  data: IExamQuizzes[];
}

export interface IExamQuizReq {
  quizCode: number;
  quizTime: number;
}

export interface ISpeakingExam {
  speakingExamCode: number;
  speakingExamName: string;
  speakingExamType: string;
  year: string;
}

export interface IGetSpeakingExams {
  result: string;
  data: ISpeakingExam[];
}

export interface IExamCheck {
  checkCode: number;
  examTestCode: number;
  checkDate: string;
  memberCode: string;
  memKorName: string;
  memEngName: string;
  completeYn: YN;
  checkType: string;
}

export interface IGetExamCheck extends IResponse<IExamCheck[]> {}

export interface IExamCheckStart {
  examTestCode: number;
  memberCode: string;
  examType: string;
  adminMode: string;
  certifyKey: string;
  checkType: string;
}

export interface IGetExamCheckStart extends IResponse<IExamCheckStart> { }

export interface IExamCheckGetUrl {
  examTestCode: number;
  memberCode: string;
  examType: string;
  adminMode: string;
  certifyKey: string;
}

export interface IExamCheckAnswer {
  examTestCode: number;
  examCode: number;
  examDiv: string;
  examTypeName: string;
  testCompleteDateTime: string | null;
  onlineExamYn: YN | null;
  examTypeCode: number;
}

export interface IGetExamCheckAnswer extends IResponse<IExamCheckAnswer> {}

export interface IExamCheckSubjectInfo {
  examSubjectCode: number;
  examTypeSubjectCode: number;
  subjectCode: number;
  subjectName: string;
}

export interface IGetExamCheckSubjectInfo
  extends IResponse<IExamCheckSubjectInfo[]> {}

export interface IAnswerInfo {
  quizSeq: number;
  quizType: QuizType;
  userAnswer: string;
  quizCode: number;
  quizAnswer: string;
  score: number;
}

export type QuizType = 41 | 51;

export interface IExamCheckAnswerCard {
  totalScore: number;
  userTotalScore: number;
  answerInfo: IAnswerInfo[];
}

export interface IGetExamCheckAnswerCard
  extends IResponse<IExamCheckAnswerCard> {}

export interface IExamCheckAnswerCardBody
  extends Pick<IAnswerInfo, 'quizCode' | 'userAnswer'> {}

  export interface IExamSemester {
    learningYearCode: string;
    regYn: string;
    semesterCode: number;
    semesterDiv: string;
    semesterEndDate: string;
    semesterName: string;
    semesterSrtDate: string;
    semesterType: string;
  }
  export interface IGetExamSemesters {
    result: string;
    data: IExamSemester[];
  }